import axios from 'axios';
import { IComisionDirectiva } from '@/shared/model/comision-directiva.model';

const baseApiUrl = 'api/comision-directivas';

export default class ComisionDirectivaService {
  public findActivas(): Promise<IComisionDirectiva[]> {
    return new Promise<IComisionDirectiva[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/activas`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public findAll(): Promise<IComisionDirectiva[]> {
    return new Promise<IComisionDirectiva[]>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public find(id: number): Promise<IComisionDirectiva> {
    return new Promise<IComisionDirectiva>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public create(entity: IComisionDirectiva): Promise<IComisionDirectiva> {
    return new Promise<IComisionDirectiva>((resolve, reject) => {
      axios
        .post(baseApiUrl, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public update(entity: IComisionDirectiva): Promise<IComisionDirectiva> {
    return new Promise<IComisionDirectiva>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
